"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import { useWaveDropsLeaderboard } from "@/hooks/useWaveDropsLeaderboard";
import { WaveSmallLeaderboardDrop } from "./WaveSmallLeaderboardDrop";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
interface WaveSmallLeaderboardProps {
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const WaveSmallLeaderboard: React.FC<WaveSmallLeaderboardProps> = t0 => {
  const $ = _c(20);
  const {
    wave,
    onDropClick
  } = t0;
  let t1;
  if ($[0] !== wave.id) {
    t1 = {
      waveId: wave.id
    };
    $[0] = wave.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    drops,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage
  } = useWaveDropsLeaderboard(t1);
  const memoizedDrops = drops;
  let t2;
  if ($[2] !== fetchNextPage || $[3] !== hasNextPage || $[4] !== isFetching || $[5] !== isFetchingNextPage) {
    t2 = () => {
      if (hasNextPage && !isFetching && !isFetchingNextPage) {
        fetchNextPage();
      }
    };
    $[2] = fetchNextPage;
    $[3] = hasNextPage;
    $[4] = isFetching;
    $[5] = isFetchingNextPage;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const intersectionElementRef = useIntersectionObserver(t2);
  let t3;
  if ($[7] !== isFetching || $[8] !== memoizedDrops || $[9] !== onDropClick || $[10] !== wave) {
    t3 = memoizedDrops.length === 0 && !isFetching ? <div className="tw-py-4 tw-text-center tw-text-iron-400">No drops have been made yet in this wave</div> : <ul className="tw-space-y-3 tw-pl-0">{memoizedDrops.map(drop => <WaveSmallLeaderboardDrop drop={drop} wave={wave} key={drop.id} onDropClick={() => onDropClick(drop)} />)}</ul>;
    $[7] = isFetching;
    $[8] = memoizedDrops;
    $[9] = onDropClick;
    $[10] = wave;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== isFetchingNextPage) {
    t4 = isFetchingNextPage && <div className="tw-h-0.5 tw-w-full tw-overflow-hidden tw-bg-iron-800"><div className="tw-size-full tw-animate-loading-bar tw-bg-indigo-400" /></div>;
    $[12] = isFetchingNextPage;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== intersectionElementRef) {
    t5 = <div ref={intersectionElementRef} />;
    $[14] = intersectionElementRef;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
    t6 = <div className="tw-p-4"><div className="tw-flex tw-flex-col">{t3}{t4}{t5}</div></div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
};